import { get, type Readable, type Unsubscriber } from "svelte/store"
/**
 * StorePender basically allows you to pass a function similar
 * to the other penders (frame and idle callback), except it's
 * reactive to a store. So if the store is set to false, it will
 * remember the function and call it when the store turns to true.
 * If the store is true.
 * 
 * 
 * **Remember to call destroy on this function!**
 */
export class StorePender<T> {
    #function : (() => unknown) | null = null
    #unsubscribe : Unsubscriber
    constructor(
        public readonly store: Readable<T>,
        /**
         * Function that tests to see whether we consider the store to be
         * ready to pass functions to or not
         */
        public readonly test: (input: T) => boolean = (t) => !!t
    ) {
        this.#unsubscribe = store.subscribe((t) => {
            if (test(t)) this.#runfunction()
        })
    }

    #runfunction() {
        if (this.#function !== null) {
            this.#function()
            this.cancel()
        }
    }

    overwrite(fn : () => unknown) {
        if (this.test(get(this.store))) {
            fn()
        } else {
            this.#function = fn
        }
    }

    cancel() {
        this.#function = null
    }

    destroy() {
        this.#unsubscribe()
    }
}
